import { createSlice } from "@reduxjs/toolkit";
import {
  getPTQuizStartThunk,
  getPTQuizCurrentThunk,
  sendPTQuizAnswerThunk,
  getPTQuizStatusThunk,
  getPTQuizSummaryThunk,
} from "./preguntasTalentoQuiz.thunks";

const initialState = {
  // status desde start/status: progreso + bandera de completadas
  status: null,

  // Pantalla activa (devuelta por current/answer)
  // {
  //   todas_completadas, talento, frase: {id, texto, tipo_fortaleza, orden},
  //   afirmaciones: [{id, texto, tipo, orden}],
  //   opciones: [{id, valor, texto}], respuestas_previas: [{sub_frase_id, valor}],
  //   frase_index, total_frases, talento_index, total_talentos,
  //   es_ultimo_talento, es_ultima_frase
  // }
  currentFrase: null,

  // Resumen final tras completar
  summary: null,

  // Respuestas en memoria para la (frase, talento) activa:
  // { [sub_frase_id]: true/false }
  respuestas: {},

  loading: false,
  statusLoading: false,
  summaryLoading: false,
  error: null,
};

const buildRespuestasInicial = (payload) => {
  const resp = {};
  (payload?.respuestas_previas || []).forEach((r) => {
    resp[r.sub_frase_id] = r.valor;
  });
  return resp;
};

const slice = createSlice({
  name: "preguntasTalentoQuiz",
  initialState,
  reducers: {
    setRespuesta: (state, action) => {
      const { subFraseId, valor } = action.payload;
      state.respuestas[subFraseId] = valor;
    },
    clearRespuestas: (state) => {
      state.respuestas = {};
    },
    resetPTQuizState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPTQuizStartThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPTQuizStartThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.status = action.payload;
      })
      .addCase(getPTQuizStartThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getPTQuizCurrentThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPTQuizCurrentThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.currentFrase = action.payload;
        state.respuestas = buildRespuestasInicial(action.payload);
      })
      .addCase(getPTQuizCurrentThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(sendPTQuizAnswerThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendPTQuizAnswerThunk.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.completado) {
          state.currentFrase = null;
          state.respuestas = {};
        } else {
          state.currentFrase = action.payload;
          state.respuestas = buildRespuestasInicial(action.payload);
        }
      })
      .addCase(sendPTQuizAnswerThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getPTQuizStatusThunk.pending, (state) => {
        state.statusLoading = true;
        state.error = null;
      })
      .addCase(getPTQuizStatusThunk.fulfilled, (state, action) => {
        state.statusLoading = false;
        state.status = action.payload;
      })
      .addCase(getPTQuizStatusThunk.rejected, (state, action) => {
        state.statusLoading = false;
        state.error = action.payload;
      })

      .addCase(getPTQuizSummaryThunk.pending, (state) => {
        state.summaryLoading = true;
        state.error = null;
      })
      .addCase(getPTQuizSummaryThunk.fulfilled, (state, action) => {
        state.summaryLoading = false;
        state.summary = action.payload;
      })
      .addCase(getPTQuizSummaryThunk.rejected, (state, action) => {
        state.summaryLoading = false;
        state.error = action.payload;
      });
  },
});

export const { setRespuesta, clearRespuestas, resetPTQuizState } = slice.actions;
export default slice.reducer;
